import apiCall from '../index'

const apiService = '/gsencuesta/api/auth'

const service = {
  login(model) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = ''
      apiCall
        .post(apiService, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  info() {
    const query = 'info'
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
          .post(apiService + query)
          .then(res => resolve(res.data))
          .catch(err => reject(err))
    })
  },
}

export default service
